import { render, staticRenderFns } from "./VICUSTOMDENY.vue?vue&type=template&id=6b33d4b8&scoped=true&"
import script from "./VICUSTOMDENY.vue?vue&type=script&lang=js&"
export * from "./VICUSTOMDENY.vue?vue&type=script&lang=js&"
import style0 from "./VICUSTOMDENY.vue?vue&type=style&index=0&id=6b33d4b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33d4b8",
  null
  
)

export default component.exports